import { reducersActions } from "./new-actions";

const { SET_START_DATE, SET_END_DATE, CLEAR_DATE_RANGE } = reducersActions;

export const setStartDate = (date) => ({
  type: SET_START_DATE,
  payload: date,
});

export const setEndDate = (date) => ({
  type: SET_END_DATE,
  payload: date,
});

export const clearDateRange = () => ({
  type: CLEAR_DATE_RANGE,
});
